// @ts-nocheck
import styled from '@emotion/styled';

import { colors, fonts } from '../../styles';

interface DescriptionProps {
  color?: string;
  ellipsis?: boolean;
}

export const DescriptionListDefault = styled('span')<DescriptionProps>`
  display: inline-block;
  color: ${(props) => props.color || colors.gray.dark};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.regular};
  line-height: 1.36;
  ${(props) =>
    props.ellipsis &&
    'white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;'};
`;

export const DescriptionListMedium = styled('span')<DescriptionProps>`
  display: inline-block;
  color: ${(props) => props.color || colors.gray.dark};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.medium};
  line-height: 1.36;
  ${(props) =>
    props.ellipsis &&
    'white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;'};
`;

export const DescriptionTitle = styled('span')<DescriptionProps>`
  display: inline-block;
  color: ${(props) => props.color || colors.black};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.medium};
  line-height: 1.36;
  ${(props) =>
    props.ellipsis &&
    'white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;'};
`;
